import { Toast } from '@seiue/ui'
import { Upload, UploadFile as AntdUploadFile, UploadProps } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { FileDirName, fileApi } from 'packages/sdks-next/growp'
import { AnyValueObj } from 'packages/types'
import React, { useState } from 'react'
import styled from 'styled-components'

export const UploadFile: React.FC<{
  content: React.ReactNode
  disabled?: boolean
  fileList?: { url: string; name: string }[]
  onChange?: (fileList: AntdUploadFile[]) => void
}> = ({ content, disabled, fileList, onChange }) => {
  const finalFileList = fileList?.map((f) => ({ ...f, uid: f.url }))
  const [OSSData, setOSSData] = useState<AnyValueObj>()

  const getOssSignature = async (file: AntdUploadFile) => {
    const { name, type } = file
    const ext = name.substring(name.lastIndexOf('.') + 1)
    let dirName = FileDirName.File
    if (type && /^image/.test(type)) {
      dirName = FileDirName.Images
    }
    if (type && /^video/.test(type)) {
      dirName = FileDirName.Video
    }
    const { data } = await fileApi.getOssSignature(ext, dirName)
    setOSSData(data)
    return data
  }

  const beforeUpload: UploadProps['beforeUpload'] = async (
    file: RcFile & { url?: string }
  ) => {
    if (finalFileList && finalFileList.length >= 6) {
      Toast.warning(`最多上传6个文件`)
      return false
    }
    const data = await getOssSignature(file)
    file.url = data.url
    return file
  }

  const uploadProps: UploadProps = {
    maxCount: 6,
    name: 'file',
    fileList: finalFileList,
    action: OSSData ? OSSData['host'] : '',
    headers: {
      'x-oss-object-acl': 'public-read',
      'X-Requested-With': '',
    },
    method: 'POST',
    data: OSSData,
    beforeUpload,
    onChange: (info) => {
      onChange && onChange(info.fileList)
    },
    listType: 'picture-card',
  }
  return (
    <Wrapper>
      <Upload
        disabled={disabled}
        {...uploadProps}
      >
        {content}
      </Upload>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  &&& {
    .ant-upload {
      height: 28px;
    }
    .ant-upload-list-picture-card-container {
      width: 80px;
      height: 80px;
      border-radius: 8px;
      margin: 0;
      margin-right: 8px;
      & .ant-upload-list-item {
        padding: 0;
        border: 1px solid transparent;
        border-radius: 8px;
        background-color: #ffffff;

        .ant-upload-list-item-thumbnail > img {
          object-fit: cover;
          border-radius: 8px;
        }

        .ant-upload-list-item-name {
          width: 100px;
          padding: 0 5px 5px 5px;
          font-size: 12px;
          color: ${(props) => props.theme.text._2};
        }
      }
    }
    .ant-upload-list-picture-card .ant-upload-list-item-info::before {
      border-radius: 8px;
      background-color: rgba(21, 37, 41, 0.6);
    }
    .ant-upload-list-item-actions {
      & .anticon-eye svg {
        fill: #ffffff;
      }
      & .ant-btn-text {
        margin-right: 0;
        svg {
          fill: #ffffff;
        }
      }
    }
    .anticon svg {
      fill: ${(props) => props.theme.text._2};
      font-size: 15px;
    }
    .anticon-file {
      position: relative;
      top: -7px;
      & > svg {
        font-size: 12px;
      }
    }
    .anticon-file svg path:first-child {
      fill: transparent;
    }
    .anticon-file svg path:last-child {
      fill: ${(props) => props.theme.text._2};
    }
  }
`
